 import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
 
import ProtectedWrapper from "../components/ProtectedWrapper"; // 👈 ye wali rehne do
import CreateBlogContent from "./CreateBlogContent";

const CreateBlog = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <ProtectedWrapper isLoggedIn={!!localStorage.getItem("token")}>
        <CreateBlogContent />
      </ProtectedWrapper>

      <Footer />
    </>
  );
};

export default CreateBlog;